import {DatePickerData, PeriodType} from '@esgi/main/kits/admin';

export const datePickerDataForInitialization: DatePickerData = {
	dateRange: null,
	datePeriod: PeriodType.None,
	trackDatesID: 0,
};
